var _rect, _rect2, _rect3, _rect4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconInbDashboardFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 3.00195,
    width: 7.71348,
    height: 7.71348,
    rx: 1,
    fill: "#CCCFD1"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 3,
    y: 13.2871,
    width: 7.71348,
    height: 7.71348,
    rx: 1,
    fill: "#CCCFD1"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2865,
    y: 3.00195,
    width: 7.71348,
    height: 7.71348,
    rx: 1,
    fill: "#CCCFD1"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 13.2866,
    y: 13.2871,
    width: 7.71348,
    height: 7.71348,
    rx: 1,
    fill: "#CCCFD1"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInbDashboardFill);
export default __webpack_public_path__ + "static/media/icon-inb-dashboard-fill.8b9c54f758e5a1e29976e2dc34035888.svg";
export { ForwardRef as ReactComponent };